import { useState } from 'react'
import { useParams } from 'react-router'

// import Avatar from '@/elements/Avatar'
import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import {
  // About,
  OfficialChannels,
  ProfileHeader,
  ReportFraudForm,
  // SponsorshipCampaigns
} from '@/components/Profile'
import useAuthStore from '@/stores/authStore'
import { useGetPrivateSubject, useGetPublicSubject } from '@/api/profile'
// import Label from '@/elements/Label'
import Loading from '@/elements/Loading'
// import { useGetAlertBySubjectId } from '@/api/alert'
import useBreakpoints from '@/hooks/useBreakpoints'
import Button from '@/elements/Button'
import { FuzzyCompact } from '@/assets'
// import type { AlertResponse } from '@/api/types/Alert'
// import { formatAsTitle } from '@/utils/format'
import AuthModal from '@/components/AuthModal'
import { getUserLocation } from '@/utils/location'

function Profile() {
  const { id: userId } = useParams<{ id: string }>()
  const { isLoggedIn } = useAuthStore()
  const { isMobile, isTablet } = useBreakpoints()
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)

  const { data: privateRecordProfile, isLoading: userLoading, isFetching } = useGetPrivateSubject(userId, isLoggedIn)
  const hasAccessToPrivateProfile = (isLoggedIn && !isFetching && privateRecordProfile?.success === true) || false

  const { data: publicRecordProfile } = useGetPublicSubject(userId, !isFetching && !hasAccessToPrivateProfile)

  // only fetch SearchRefinement when private profile is successfully fetched
  // const { data: searchRefinementData } = useGetIndividualSearchRefinement(userId || '', hasAccessToPrivateProfile)

  // const { page, limit, setPage } = usePagination(5)
  // const { data: alertsData, isLoading: alertsLoading, refetch: refetchAlerts } = useGetAlertBySubjectId({
  //   subjectId: userId, page, limit
  // }, !!isLoggedIn && hasAccessToPrivateProfile && hasOrganizations)
  // const alerts: AlertResponse[] = alertsData?.data?.items || []

  const profileToUse = hasAccessToPrivateProfile ? privateRecordProfile : publicRecordProfile

  const avatarImg = profileToUse?.data?.user.assets?.PROFILE_PICTURE
  const coverImg = profileToUse?.data?.user.assets?.COVER
  const name = profileToUse?.data?.user.details.fullName
  const location = profileToUse?.data?.user.details ? getUserLocation(profileToUse.data.user.details) : undefined
  const group = profileToUse?.data?.group?.name
  const position = profileToUse?.data?.details.occupation
  const channels = profileToUse?.data?.details.social
  // const circle = profileToUse?.data?.innerCircle
  const verified = profileToUse?.data?.user.isVerified
  // const sponsorships = profileToUse?.data?.sponsorships

  return (
    <Flex component='section' gap={!isMobile ? 4 : 3} grow>
      {!userId || userLoading ? (
        <Loading />
      ) : (
        <>
          <ProfileHeader
            avatar={avatarImg || undefined}
            cover={coverImg || undefined}
            name={name || '--'}
            location={location || '--'}
            group={group || '--'}
            position={position || '--'}
            verified={verified || false}
          />
          <Flex
            wfull
            wrap
            gap={!isMobile ? 4 : 3}
            grow
            style={{
              flexDirection: isTablet
                ? (hasAccessToPrivateProfile ? 'column-reverse' : 'column')
                : 'row'
            }}
          >
            <Flex fraction={5} wfull pt={hasAccessToPrivateProfile ? 'unset' : 4}>
              {!isLoggedIn ? (
                <Flex wfull gap={3} hfull>
                  <Text variant='h3'>Report suspected fraud</Text>
                  <Button
                    variant='accent'
                    onClick={() => setIsAuthModalOpen(true)}
                    fullWidth={isMobile}
                  >
                    <FuzzyCompact width={24} height={24} />
                    Authenticate with Fuzzy
                  </Button>
                </Flex>
              ) : (
                <ReportFraudForm subjectId={userId} />
              )}
            </Flex>
            <Flex wfull fraction={3}>
              {/* <Flex wfull>
                <Flex wfull justify='end' style={{ height: !isTablet ? 54 : 'auto' }} mb={3}>
                  <Label position='left' uppercase>About</Label>
                </Flex>
                <About
                  searchRefinementData={searchRefinementData?.data ?? {}}
                  alias={profileToUse?.data?.alias}
                />
              </Flex> */}
              <OfficialChannels channels={channels} />
              {/* {sponsorships && sponsorships?.length > 0 && (
                <Flex wfull gap={2}>
                  <Label uppercase>Sponsorship Campaigns</Label>
                  <SponsorshipCampaigns campaigns={sponsorships} />
                </Flex>
              )} */}
              {/* {isLoggedIn && hasAccessToPrivateProfile && hasOrganizations && (
                <Flex wfull gap={2}>
                  <Label uppercase>Inner Circle</Label>
                  <Flex wfull p={!isMobile ? 4 : 3} gap={3} className='card'>
                    {circle?.length === 0 ? (
                      <Flex wfull align='center' py={4}>
                        <Text color='black-light-60'>No members to display yet.</Text>
                      </Flex>
                    ) : (
                      circle?.map(member => (
                        <Flex align='center' inline gap={3} key={member.user.id}>
                          <Avatar
                            name={member.user.details.fullName || ''}
                            src={member.user.assets?.PROFILE_PICTURE ?? undefined}
                            size='medium'
                            isMember
                          />
                          <Flex>
                            <Text color='black-light-20'>{member.user.details.fullName}</Text>
                            <Text variant='textblock' color='black-light-40'>{formatAsTitle(member.type)}</Text>
                          </Flex>
                        </Flex>
                      ))
                    )}
                  </Flex>
                </Flex>
              )} */}
            </Flex>
          </Flex>
        </>
      )}

      <AuthModal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} />
    </Flex>
  )
}

export default Profile
